import React from 'react';
/* eslint-disable import/no-extraneous-dependencies */
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import HeroBannerRootElement from './style';
import Search from '../Search';
import SecondaryNav from './secondaryNav';
import { isMobileDevice } from '../../../utils/srp.util';

const HeroBanner = () => {
  const { t } = useTranslation();

  return (
    <HeroBannerRootElement>
      <SecondaryNav />
      <Box className="page-container">
        <Box className="intro">
          {
            !isMobileDevice() ? (
              <>
                <Typography variant="body-copy-small" color="ink-on-background">
                  {t('AUTODESK PARTNER FINDER')}
                </Typography>
                <Typography
                  variant="headline-larger"
                  component="h1"
                  mt={2}
                >
                  {t('Approved Partners and Consultants')}
                  <br />
                  {t('who can help at any stage')}
                </Typography>
                <Typography variant="body-copy-medium" mb={7} className="sub-description title-sub">
                  {t('Find certified partners and trusted consultants who understand your business needs using the Autodesk Partner Finder for resellers, solutions, implementation, or support services')}
                </Typography>
              </>
            ) : (
              <>
                <Typography
                  variant="headline-larger"
                  component="h1"
                >
                  {t('Approved Partners and Consultants')}
                  <br />
                  {t('who can help at any stage')}
                </Typography>
                <Typography variant="body-copy-medium" mb={7} className="sub-description title-sub">
                  {t('Find certified partners and trusted consultants who understand your business needs using the Autodesk Partner Finder for resellers, solutions, implementation, or support services')}
                </Typography>
              </>
            )
          }
        </Box>
      </Box>
      <Search />
    </HeroBannerRootElement>
  );
};

export default HeroBanner;
